export let userCar = {
    class: "Subcompact",
    year: 2021,
    make: 'Tesla',
    model: 'Model 3',
    power_type: 'EV'
    /*
    let userCar = 
        {
            class: "Subcompact",
            year: 2021,
            make: 'Tesla',
            model: 'Model 3',
            power_type: 'EV'
        }
    };
    let kms = 0;
    let purchaseDate = 2020;*/
}